export enum Equipments {
  BoosterSeat = 1,
  CarSeatwith5PointsHarness = 2,
  BuckleGuard = 3,
  Harness = 4,
  HighBackBoosterSeatwithStraps = 5,
  HighBackBoosterSeat = 6,
  MiddleDivider = 7,
}
